import { CRICKET_THEMES, IMAGES_THEMES, SPORTS_THEMES } from './getSupportedThemes';
import { getPackageBaseUrl } from 'owa-config';
import { urlResolve } from 'mini-common-utils/lib/utils/urlResolve';
import type { ThemeId } from '../schema/ThemeId';

const THEMES_WITH_LIGHT_AND_DARK_HERO_IMAGE = [...CRICKET_THEMES, ...IMAGES_THEMES];
const THEMES_WITH_SINGLE_HERO_IMAGE = SPORTS_THEMES;

export const getThemeHeroImage = (themeId: ThemeId, isDarkTheme: boolean) => {
    const baseUrl = getPackageBaseUrl();
    const basePath = `resources/themes/heroImages/${themeId}`;

    if (THEMES_WITH_LIGHT_AND_DARK_HERO_IMAGE.includes(themeId)) {
        return urlResolve(baseUrl, `${basePath}_${isDarkTheme ? 'Dark' : 'Light'}.png`);
    }

    if (THEMES_WITH_SINGLE_HERO_IMAGE.includes(themeId)) {
        return urlResolve(baseUrl, `${basePath}.png`);
    }

    return null;
};
